/** App-bar entry point for API debug mode. Only mounted for holders of the
 *  `console_debug` permission (PermissionGate in AppShell). The filled icon +
 *  warning badge make an armed debug mode visually loud. */
import BugReportIcon from '@mui/icons-material/BugReport';
import BugReportOutlinedIcon from '@mui/icons-material/BugReportOutlined';
import { Badge, IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';

import { DebugDrawer } from './DebugDrawer';
import { useDebugMode } from './useDebugMode';

export function DebugToolbarButton() {
  const [open, setOpen] = useState(false);
  const { enabled, entries } = useDebugMode();
  return (
    <>
      <Tooltip title={enabled ? 'API debug (recording)' : 'API debug'}>
        <IconButton color="inherit" aria-label="API debug" onClick={() => setOpen(true)}>
          {enabled ? (
            <Badge badgeContent={entries.length} color="warning" max={99}>
              <BugReportIcon />
            </Badge>
          ) : (
            <BugReportOutlinedIcon />
          )}
        </IconButton>
      </Tooltip>
      <DebugDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
